module.exports = __webpack_public_path__ + "static/media/sign-language.99a124c2.svg";